// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"6e7d4b06","946":"1f58c8db"}[chunkId] + ".chunk.js";
};